// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import {
//   Container,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Checkbox,
//   IconButton,
//   Button,
//   TextField,
//   MenuItem,
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Alert,
//   Snackbar,
//   CircularProgress,
//   InputAdornment,
//   Tooltip,
//   Grid,
//   Stack,
// } from '@mui/material';
// import {
//   Add as AddIcon,
//   ContentCopy as ContentCopyIcon,
//   GetApp as GetAppIcon,
//   ImportExport as ImportExportIcon,
//   Close as CloseIcon,
//   ControlPointDuplicate as ControlPointDuplicateIcon,
//   Search as SearchIcon,
//   FilterList as FilterListIcon,
//   Delete as DeleteIcon,
//   Edit as EditIcon,
//   Clear as ClearIcon,
//   Home as HomeIcon,
//   KeyboardArrowRight as KeyboardArrowRightIcon,
// } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_All_Sales_Action, Update_one_Sales_Action } from '../../Redux/Actions/SalesAction';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import XLSX from '../../utils/excelUtils';
// import axios from 'axios';
// import moment from 'moment';
// import { useTheme } from '@mui/material/styles';
// import { Notify } from '../../Utility/Notify';
// import { db_url } from '../../Api/BaseUrl';

// export const SalesMain = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   const [loading, setLoading] = useState(true);
//   const [selectedSales, setSelectedSales] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [roleFilter, setRoleFilter] = useState('all');
//   const [cityFilter, setCityFilter] = useState('all');

//   // Pagination states
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Dialog states
//   const [importDialogOpen, setImportDialogOpen] = useState(false);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   const [file, setFile] = useState(null);
//   const [importMessage, setImportMessage] = useState('');
//   const [importLoading, setImportLoading] = useState(false);
//   const [fileName, setFileName] = useState('');

//   const get_sales_data = async () => {
//     setLoading(true);
//     await dispatch(Get_All_Sales_Action());
//     setLoading(false);
//   };

//   useEffect(() => {
//     get_sales_data();
//   }, [dispatch]);

//   const resAll_Sales = useSelector((state) => state.AllSales.sales);
//   let allsales = (Array.isArray(resAll_Sales?.data) ? resAll_Sales.data : []).filter(
//     (sale) =>
//       sale.name !== 'No Sales' &&
//       sale.name !== 'Default' &&
//       sale.name !== 'Default M' &&
//       sale.name !== 'Default T' &&
//       sale.name !== 'Default S' &&
//       sale.name !== 'Deveolper' &&
//       sale.name !== 'Dev',
//   );

//   if (allsales) {
//     allsales = allsales?.map((item) => ({
//       _id: item?._id,
//       name: item?.name,
//       city: item?.city?.map((c) => c.name).join(', '),
//       notes: item?.notes,
//       userlogName: item?.userlog ? item?.userlog?.name : '',
//       userlogEmail: item?.userlog ? item?.userlog?.email : '',
//       userlogRole: item?.userlog ? item?.userlog?.role : '',
//       createdAt: item?.createdAt,
//       updatedAt: item?.updatedAt,
//     }));
//   }

//   // Filtering logic
//   const filteredSales = allsales.filter((sale) => {
//     const matchesSearch =
//       sale.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       sale.userlogEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       sale.notes?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesRole = roleFilter === 'all' || sale.userlogRole === roleFilter;
//     const matchesCity =
//       cityFilter === 'all' || sale.city?.toLowerCase().includes(cityFilter.toLowerCase());

//     return matchesSearch && matchesRole && matchesCity;
//   });

//   // Pagination logic
//   const paginatedSales = filteredSales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

//   // Get unique values for filters
//   const uniqueRoles = [...new Set(allsales.map((sale) => sale.userlogRole))].filter((role) => role);
//   const uniqueCities = [
//     ...new Set(allsales.flatMap((sale) => sale.city?.split(', ')).filter((city) => city)),
//   ];

//   // Selection handlers
//   const handleSelectAll = () => {
//     if (selectedSales.length === paginatedSales.length) {
//       setSelectedSales([]);
//     } else {
//       setSelectedSales(paginatedSales.map((s) => s._id));
//     }
//   };

//   const handleSelectOne = (id) => {
//     setSelectedSales((prev) =>
//       prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
//     );
//   };

//   const isSelected = (id) => selectedSales.includes(id);

//   // Pagination handlers
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Export to Excel
//   const exportToExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredSales);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sales Data');
//     XLSX.writeFile(wb, `sales_data_${moment().format('YYYY-MM-DD')}.xlsx`);
//   };

//   // Import handlers
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     setFile(selectedFile);
//     setFileName(selectedFile ? selectedFile.name : '');
//   };

//   const handleImportSubmit = async (e) => {
//     e.preventDefault();
//     if (!file) {
//       setImportMessage('Please select a file to upload');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       setImportLoading(true);
//       setImportMessage('');
//       await axios.post(`${db_url}api/v1/Sales/import`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setImportMessage('Sales imported successfully!');
//       setImportLoading(false);
//       setTimeout(() => {
//         setImportDialogOpen(false);
//         get_sales_data();
//       }, 2000);
//     } catch (error) {
//       setImportLoading(false);
//       setImportMessage(
//         'Error importing Sales: ' + (error.response?.data?.message || error.message),
//       );
//     }
//   };

//   // Delete handler
//   const handleDelete = async () => {
//     try {
//       for (let id of selectedSales) {
//         await dispatch(Update_one_Sales_Action(id, { salesisactivate: false }));
//       }
//       Notify('success', 'Selected sales deleted successfully!', 'success');
//       get_sales_data();
//       setSelectedSales([]);
//       setDeleteDialogOpen(false);
//     } catch (error) {
//       Notify('error', 'Error deleting selected sales', 'error');
//     }
//   };

//   // Clear filters
//   const clearFilters = () => {
//     setSearchTerm('');
//     setRoleFilter('all');
//     setCityFilter('all');
//     setPage(0);
//   };

//   return (
//     <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
//       {/* Breadcrumb */}
//       <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
//         <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none' }}>
//           <Button startIcon={<HomeIcon />} sx={{ color: '#102dff' }}>
//             Home
//           </Button>
//         </Link>
//         <KeyboardArrowRightIcon sx={{ color: '#666' }} />
//         <Typography variant="body1" color="text.secondary">
//           Sales
//         </Typography>
//       </Stack>

//       {/* Header Card */}
//       <Card sx={{ mb: 3, backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff' }}>
//         <CardContent>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={8}>
//               <Typography variant="h5" fontWeight="bold" gutterBottom>
//                 Sales Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Manage your sales team and track performance
//               </Typography>
//             </Grid>
//             <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
//               <Link to="/Addsales" style={{ textDecoration: 'none' }}>
//                 <Button
//                   variant="contained"
//                   startIcon={<AddIcon />}
//                   sx={{
//                     backgroundColor: '#102dff',
//                     '&:hover': { backgroundColor: '#0a1fcc' },
//                     px: 3,
//                   }}
//                 >
//                   Add New Sales
//                 </Button>
//               </Link>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>

//       {/* Filter Section */}
//       <Paper sx={{ p: 3, mb: 3, backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa' }}>
//         <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
//           <FilterListIcon sx={{ color: '#102dff' }} />
//           <Typography variant="h6">Filter Sales</Typography>
//         </Stack>

//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={4}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by name, email, or notes..."
//               value={searchTerm}
//               onChange={(e) => {
//                 setSearchTerm(e.target.value);
//                 setPage(0);
//               }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchTerm && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchTerm('')}>
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <TextField
//               select
//               fullWidth
//               size="small"
//               label="Filter by Role"
//               value={roleFilter}
//               onChange={(e) => {
//                 setRoleFilter(e.target.value);
//                 setPage(0);
//               }}
//             >
//               <MenuItem value="all">All Roles</MenuItem>
//               {uniqueRoles.map((role) => (
//                 <MenuItem key={role} value={role}>
//                   {role}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <TextField
//               select
//               fullWidth
//               size="small"
//               label="Filter by City"
//               value={cityFilter}
//               onChange={(e) => {
//                 setCityFilter(e.target.value);
//                 setPage(0);
//               }}
//             >
//               <MenuItem value="all">All Cities</MenuItem>
//               {uniqueCities.map((city) => (
//                 <MenuItem key={city} value={city}>
//                   {city}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>

//           <Grid item xs={12} md={2}>
//             <Button fullWidth variant="outlined" onClick={clearFilters} sx={{ height: 40 }}>
//               Clear Filters
//             </Button>
//           </Grid>
//         </Grid>

//         {/* Filter Summary */}
//         <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//           <Chip
//             label={`Total: ${allsales.length}`}
//             color="primary"
//             variant="outlined"
//             size="small"
//           />
//           <Chip
//             label={`Filtered: ${filteredSales.length}`}
//             color="secondary"
//             variant="outlined"
//             size="small"
//           />
//           {searchTerm && (
//             <Chip
//               label={`Search: "${searchTerm}"`}
//               onDelete={() => setSearchTerm('')}
//               size="small"
//             />
//           )}
//           {roleFilter !== 'all' && (
//             <Chip
//               label={`Role: ${roleFilter}`}
//               onDelete={() => setRoleFilter('all')}
//               size="small"
//             />
//           )}
//           {cityFilter !== 'all' && (
//             <Chip
//               label={`City: ${cityFilter}`}
//               onDelete={() => setCityFilter('all')}
//               size="small"
//             />
//           )}
//         </Box>
//       </Paper>

//       {/* Action Buttons */}
//       <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
//         <Button
//           variant="contained"
//           startIcon={<GetAppIcon />}
//           onClick={exportToExcel}
//           sx={{
//             backgroundColor: '#102dff',
//             '&:hover': { backgroundColor: '#0a1fcc' },
//           }}
//         >
//           Export to Excel
//         </Button>
//         <Button
//           variant="contained"
//           startIcon={<ImportExportIcon />}
//           onClick={() => setImportDialogOpen(true)}
//           sx={{
//             backgroundColor: '#28a745',
//             '&:hover': { backgroundColor: '#218838' },
//           }}
//         >
//           Import from Excel
//         </Button>
//         {selectedSales.length > 0 && (
//           <>
//             <Button
//               variant="contained"
//               color="error"
//               startIcon={<DeleteIcon />}
//               onClick={() => setDeleteDialogOpen(true)}
//             >
//               Delete Selected ({selectedSales.length})
//             </Button>
//             {selectedSales.length === 1 && (
//               <Link to={`/updatesales/${selectedSales[0]}`} style={{ textDecoration: 'none' }}>
//                 <Button variant="contained" color="warning" startIcon={<EditIcon />}>
//                   Edit Selected
//                 </Button>
//               </Link>
//             )}
//           </>
//         )}
//       </Stack>

//       {/* Sales Table */}
//       <Paper sx={{ width: '100%', overflow: 'hidden', mb: 3 }}>
//         <TableContainer sx={{ maxHeight: 600 }}>
//           <Table stickyHeader size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell padding="checkbox">
//                   <Checkbox
//                     color="primary"
//                     indeterminate={
//                       selectedSales.length > 0 && selectedSales.length < paginatedSales.length
//                     }
//                     checked={
//                       paginatedSales.length > 0 && selectedSales.length === paginatedSales.length
//                     }
//                     onChange={handleSelectAll}
//                   />
//                 </TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>ID</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>Name</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>City</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>Notes</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>User Info</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>Created At</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                     <CircularProgress sx={{ color: '#102dff' }} />
//                     <Typography variant="body2" sx={{ mt: 1 }}>
//                       Loading sales data...
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : paginatedSales.length > 0 ? (
//                 paginatedSales.map((sale) => {
//                   const isItemSelected = isSelected(sale._id);
//                   return (
//                     <TableRow
//                       key={sale._id}
//                       hover
//                       selected={isItemSelected}
//                       sx={{
//                         '&:hover': {
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
//                         },
//                       }}
//                     >
//                       <TableCell padding="checkbox">
//                         <Checkbox
//                           color="primary"
//                           checked={isItemSelected}
//                           onChange={() => handleSelectOne(sale._id)}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                           <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
//                             {sale._id.substring(0, 8)}...
//                           </Typography>
//                           <CopyToClipboard text={sale._id}>
//                             <Tooltip title="Copy ID">
//                               <IconButton size="small">
//                                 <ContentCopyIcon fontSize="small" sx={{ color: '#102dff' }} />
//                               </IconButton>
//                             </Tooltip>
//                           </CopyToClipboard>
//                         </Stack>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2" color="text.primary">
//                           {sale.name}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2" color="text.secondary">
//                           {sale.city}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           sx={{
//                             maxWidth: 200,
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             whiteSpace: 'nowrap',
//                           }}
//                         >
//                           {sale.notes || '-'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Box>
//                           <Typography variant="body2" fontWeight="medium">
//                             {sale.userlogName}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary" display="block">
//                             {sale.userlogRole}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary" display="block">
//                             {sale.userlogEmail}
//                           </Typography>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2" color="text.secondary">
//                           {sale.createdAt
//                             ? moment(sale.createdAt).format('DD/MM/YYYY h:mm A')
//                             : '-'}
//                         </Typography>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                     <Typography variant="body1" color="text.secondary">
//                       No sales data found
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                       {searchTerm || roleFilter !== 'all' || cityFilter !== 'all'
//                         ? 'Try adjusting your filters'
//                         : 'Add your first sales entry'}
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25, 50]}
//           component="div"
//           count={filteredSales.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           labelRowsPerPage="Rows per page:"
//           labelDisplayedRows={({ from, to, count }) =>
//             `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
//           }
//           sx={{
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//             borderTop: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//           }}
//         />
//       </Paper>

//       {/* Import Dialog */}
//       <Dialog
//         open={importDialogOpen}
//         onClose={() => setImportDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <ImportExportIcon />
//             <Typography variant="h6">Import Sales from Excel</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent>
//           <form onSubmit={handleImportSubmit}>
//             <Box sx={{ mt: 2, mb: 3 }}>
//               <input
//                 accept=".xlsx,.xls"
//                 style={{ display: 'none' }}
//                 id="file-upload"
//                 type="file"
//                 onChange={handleFileChange}
//               />
//               <label htmlFor="file-upload">
//                 <Button
//                   variant="outlined"
//                   component="span"
//                   startIcon={<ControlPointDuplicateIcon />}
//                   fullWidth
//                   sx={{ py: 2, mb: 2 }}
//                 >
//                   Choose Excel File
//                 </Button>
//               </label>
//               {fileName && (
//                 <Alert severity="info" sx={{ mb: 2 }}>
//                   Selected file: {fileName}
//                 </Alert>
//               )}
//               {importMessage && (
//                 <Alert
//                   severity={importMessage.includes('Error') ? 'error' : 'success'}
//                   sx={{ mb: 2 }}
//                 >
//                   {importMessage}
//                 </Alert>
//               )}
//             </Box>
//           </form>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setImportDialogOpen(false)} startIcon={<CloseIcon />}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleImportSubmit}
//             variant="contained"
//             disabled={!file || importLoading}
//             startIcon={importLoading ? <CircularProgress size={20} /> : <ImportExportIcon />}
//           >
//             {importLoading ? 'Importing...' : 'Import File'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <DeleteIcon color="error" />
//             <Typography variant="h6">Confirm Deletion</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body1" sx={{ mt: 2 }}>
//             Are you sure you want to delete {selectedSales.length} selected sales?
//           </Typography>
//           <Alert severity="warning" sx={{ mt: 2 }}>
//             This action cannot be undone. The selected sales will be permanently removed.
//           </Alert>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button
//             onClick={handleDelete}
//             variant="contained"
//             color="error"
//             startIcon={<DeleteIcon />}
//           >
//             Delete Selected
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for selections */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={() => setSnackbarOpen(false)} severity="info" sx={{ width: '100%' }}>
//           {selectedSales.length} sales selected
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };






















// 20-5-2026
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert, CircularProgress } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import axios from 'axios';
import { Get_All_Sales_Action, Update_one_Sales_Action } from '../../Redux/Actions/SalesAction';
import { Notify } from '../../Utility/Notify';
import { db_url } from '../../Api/BaseUrl';
import XLSX from '../../utils/excelUtils';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconDownload = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IconUpload   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>;
const IconTrash    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const IconEdit     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconClose    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconWarning  = () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IconUsers    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconTrend    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconCity     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9.5L12 3l9 6.5V21H3V9.5z"/><rect x="9" y="14" width="6" height="7" rx="1"/></svg>;

/* ─── Searchable Dropdown ────────────────────────────────────────────────── */
const SearchableSelect = ({ value, onChange, options = [], placeholder, isDark }) => {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filtered = options.filter(o => o.toLowerCase().includes(search.toLowerCase()));

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '8px 12px', borderRadius: '8px', cursor: 'pointer',
          border: `1.5px solid ${isDark ? '#3a3a5a' : '#e0e2ef'}`,
          background: isDark ? '#252540' : '#fff',
          color: isDark ? (value ? '#e0e0ff' : '#7070a0') : (value ? '#1f2937' : '#9ca3af'),
          fontSize: '13px', fontFamily: "'DM Sans',sans-serif",
          userSelect: 'none',
        }}
      >
        <span>{value || placeholder}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', opacity: 0.5 }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 9999,
          background: isDark ? '#1e1e38' : '#fff',
          border: `1.5px solid ${isDark ? '#3a3a5a' : '#e0e2ef'}`,
          borderRadius: '10px', boxShadow: isDark ? '0 12px 32px rgba(0,0,0,0.5)' : '0 8px 24px rgba(0,0,0,0.12)',
          overflow: 'hidden',
          animation: 'ss-open 0.14s ease both',
        }}>
          <div style={{ padding: '8px', borderBottom: `1px solid ${isDark ? '#2a2a45' : '#f0f0f0'}` }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: isDark ? '#252540' : '#f5f6fa',
              border: `1px solid ${isDark ? '#3a3a5a' : '#e5e7ef'}`,
              borderRadius: '6px', padding: '6px 10px',
            }}>
              <IconSearch />
              <input
                autoFocus value={search} onChange={e => setSearch(e.target.value)}
                placeholder="Search…"
                style={{ border: 'none', background: 'none', outline: 'none', fontSize: '12px', width: '100%', color: isDark ? '#e0e0ff' : '#1f2937', fontFamily: "'DM Sans',sans-serif" }}
              />
              {search && <button onClick={() => setSearch('')} style={{ border: 'none', background: 'none', cursor: 'pointer', color: isDark ? '#7070a0' : '#9ca3af', fontSize: '12px' }}>✕</button>}
            </div>
          </div>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            <div
              onClick={() => { onChange('all'); setOpen(false); setSearch(''); }}
              style={{
                padding: '9px 14px', fontSize: '13px', cursor: 'pointer',
                color: !value || value === 'all' ? (isDark ? '#90b4ff' : '#0d2a6e') : (isDark ? '#e0e0ff' : '#374151'),
                fontWeight: !value || value === 'all' ? 600 : 400,
                background: !value || value === 'all' ? (isDark ? '#1d2a5e' : '#eef1fb') : 'transparent',
                borderLeft: !value || value === 'all' ? '3px solid #1d4ed8' : '3px solid transparent',
              }}
            >
              {placeholder}
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding: '14px', textAlign: 'center', fontSize: '12px', color: isDark ? '#6b7280' : '#9ca3af' }}>No results</div>
            ) : filtered.map(o => (
              <div
                key={o}
                onClick={() => { onChange(o); setOpen(false); setSearch(''); }}
                style={{
                  padding: '9px 14px', fontSize: '13px', cursor: 'pointer',
                  color: value === o ? (isDark ? '#90b4ff' : '#0d2a6e') : (isDark ? '#e0e0ff' : '#374151'),
                  fontWeight: value === o ? 600 : 400,
                  background: value === o ? (isDark ? '#1d2a5e' : '#eef1fb') : 'transparent',
                  borderLeft: value === o ? '3px solid #1d4ed8' : '3px solid transparent',
                }}
                onMouseEnter={e => { if (value !== o) e.currentTarget.style.background = isDark ? '#252545' : '#f5f7ff'; }}
                onMouseLeave={e => { if (value !== o) e.currentTarget.style.background = 'transparent'; }}
              >{o}</div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── Portal Modal ───────────────────────────────────────────────────────── */
const PortalModal = ({ isDark, title, subtitle, onClose, onConfirm, confirmLabel, confirmColor = '#E53935', loading, children }) =>
  createPortal(
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(10px)', animation: 'pm-fade 0.2s ease both' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        width: '100%', maxWidth: '480px', margin: '0 20px',
        borderRadius: '24px', padding: '36px 32px 32px',
        background: isDark ? 'linear-gradient(135deg,#1a1f2e,#141829)' : '#fff',
        boxShadow: '0 40px 100px rgba(0,0,0,0.35)', position: 'relative',
        animation: 'pm-slide 0.26s cubic-bezier(0.34,1.2,0.64,1) both',
        color: isDark ? '#E4E8F5' : '#1C2340',
      }}>
        {/* close */}
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, width: 34, height: 34, borderRadius: '10px', border: `1px solid ${isDark ? '#3A4570' : '#E8EAF0'}`, background: isDark ? '#252D4A' : '#F7F8FC', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#9099c0' : '#7B829A' }}>
          <IconClose />
        </button>

        {/* icon */}
        <div style={{ width: 76, height: 76, borderRadius: '50%', background: `linear-gradient(135deg,${confirmColor}22,${confirmColor}44)`, border: `2px solid ${confirmColor}66`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', color: confirmColor }}>
          <IconWarning />
        </div>

        <p style={{ fontSize: '20px', fontWeight: 700, textAlign: 'center', margin: '0 0 8px', letterSpacing: '-0.3px' }}>{title}</p>
        <p style={{ fontSize: '13px', color: isDark ? '#7B829A' : '#6b7280', textAlign: 'center', margin: '0 0 24px', lineHeight: 1.6 }}>{subtitle}</p>

        {children}

        <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
          <button onClick={onClose} disabled={loading} style={{ flex: 1, padding: '13px', borderRadius: '12px', border: `1.5px solid ${isDark ? '#3A4570' : '#E8EAF0'}`, background: isDark ? '#252D4A' : '#F7F8FC', color: isDark ? '#E4E8F5' : '#1C2340', fontFamily: "'DM Sans',sans-serif", fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={onConfirm} disabled={loading} style={{ flex: 1, padding: '13px', borderRadius: '12px', border: 'none', background: `linear-gradient(135deg,${confirmColor},${confirmColor}cc)`, color: '#fff', fontFamily: "'DM Sans',sans-serif", fontSize: '14px', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', opacity: loading ? 0.7 : 1 }}>
            {loading ? <><div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'pm-spin 0.7s linear infinite' }} />Processing…</> : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );

/* ─── Constants ──────────────────────────────────────────────────────────── */
const EXPANDED_WIDTH = 242;

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const SalesMain = () => {
  const dispatch = useDispatch();
  const theme    = useTheme();
  const mode     = theme.palette.mode;
  const isDark   = mode === 'dark';

  const [loading,         setLoading]         = useState(true);
  const [searchTerm,      setSearchTerm]       = useState('');
  const [roleFilter,      setRoleFilter]       = useState('all');
  const [cityFilter,      setCityFilter]       = useState('all');
  const [showFilter,      setShowFilter]       = useState(false);
  const [page,            setPage]             = useState(1);
  const [itemsPerPage,    setItemsPerPage]     = useState(10);
  const [selectedSales,   setSelectedSales]    = useState([]);
  const [copyOpen,        setCopyOpen]         = useState(false);
  // const [sidebarWidth,    setSidebarWidth]     = useState(EXPANDED_WIDTH);
  const sidebarWidth = useSidebarWidth();

  // modals
  const [showDelete,      setShowDelete]       = useState(false);
  const [deleteLoading,   setDeleteLoading]    = useState(false);
  const [showImport,      setShowImport]       = useState(false);
  const [importFile,      setImportFile]       = useState(null);
  const [importFileName,  setImportFileName]   = useState('');
  const [importLoading,   setImportLoading]    = useState(false);
  const [importMsg,       setImportMsg]        = useState('');

  // useEffect(() => {
  //   const h = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', h);
  //   return () => window.removeEventListener('sidebarResized', h);
  // }, []);

  const getSalesData = async () => {
    setLoading(true);
    await dispatch(Get_All_Sales_Action());
    setLoading(false);
  };
  useEffect(() => { getSalesData(); }, [dispatch]);

  const resAll_Sales = useSelector((state) => state.AllSales.sales);
  const EXCLUDE = ['No Sales','Default','Default M','Default T','Default S','Deveolper','Dev'];
  let allsales = (Array.isArray(resAll_Sales?.data) ? resAll_Sales.data : [])
    .filter(s => !EXCLUDE.includes(s.name))
    .map(item => ({
      _id: item?._id,
      name: item?.name,
      city: item?.city?.map(c => c.name).join(', '),
      notes: item?.notes,
      userlogName:  item?.userlog?.name  || '',
      userlogEmail: item?.userlog?.email || '',
      userlogRole:  item?.userlog?.role  || '',
      createdAt: item?.createdAt,
    }));

  /* filter */
  const filtered = allsales.filter(s => {
    const q = searchTerm.toLowerCase();
    const matchSearch = !q || s.name?.toLowerCase().includes(q) || s.userlogEmail?.toLowerCase().includes(q) || s.notes?.toLowerCase().includes(q);
    const matchRole = roleFilter === 'all' || s.userlogRole === roleFilter;
    const matchCity = cityFilter === 'all' || s.city?.toLowerCase().includes(cityFilter.toLowerCase());
    return matchSearch && matchRole && matchCity;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  /* unique filter options */
  const uniqueRoles  = [...new Set(allsales.map(s => s.userlogRole).filter(Boolean))];
  const uniqueCities = [...new Set(allsales.flatMap(s => s.city?.split(', ')).filter(Boolean))];

  /* stats */
  const thisMonth = allsales.filter(s => moment(s.createdAt).isAfter(moment().subtract(30, 'days'))).length;

  /* checkbox */
  const isAllSelected  = pageItems.length > 0 && pageItems.every(s => selectedSales.includes(s._id));
  const isSomeSelected = selectedSales.length > 0 && !isAllSelected;
  const handleSelectAll = (e) => {
    if (e.target.checked) setSelectedSales(pageItems.map(s => s._id));
    else setSelectedSales([]);
  };
  const handleSelectOne = (id) => {
    setSelectedSales(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  /* export */
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filtered);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sales');
    XLSX.writeFile(wb, `sales_${moment().format('YYYY-MM-DD')}.xlsx`);
  };

  /* import */
  const handleImportSubmit = async () => {
    if (!importFile) { setImportMsg('Please select a file'); return; }
    const formData = new FormData();
    formData.append('file', importFile);
    try {
      setImportLoading(true); setImportMsg('');
      await axios.post(`${db_url}api/v1/Sales/import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setImportMsg('Imported successfully!');
      setTimeout(() => { setShowImport(false); setImportMsg(''); getSalesData(); }, 1800);
    } catch (err) {
      setImportMsg('Error: ' + (err.response?.data?.message || err.message));
    } finally { setImportLoading(false); }
  };

  /* delete */
  const handleDelete = async () => {
    setDeleteLoading(true);
    for (const id of selectedSales) {
      await dispatch(Update_one_Sales_Action(id, { salesisactivate: false }));
    }
    setDeleteLoading(false);
    setShowDelete(false);
    setSelectedSales([]);
    Notify('success', `${selectedSales.length} sales deleted successfully`, 'success');
    getSalesData();
  };

  /* page numbers */
  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4)                   pages.push(1, 2, 3, 4, 5, '...', totalPages);
    else if (page >= totalPages - 3) pages.push(1, '...', totalPages-4, totalPages-3, totalPages-2, totalPages-1, totalPages);
    else                             pages.push(1, '...', page-1, page, page+1, '...', totalPages);
    return pages;
  };

  /* ── render ── */
  return (
    <>
      <style>{`
        @keyframes ss-open { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }
        @keyframes pm-fade  { from { opacity:0; } to { opacity:1; } }
        @keyframes pm-slide { from { opacity:0; transform:translateY(24px) scale(0.96); } to { opacity:1; transform:none; } }
        @keyframes pm-spin  { to { transform:rotate(360deg); } }
      `}</style>

      <div
        className={`ap-shell ${mode}`}
        style={{
          position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0,
          transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
          overflowY: 'auto', overflowX: 'hidden',
          display: 'flex', flexDirection: 'column',
        }}
      >

        {/* ─── Breadcrumb ─── */}
        <section style={{ padding: '16px 20px 0', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans',sans-serif" }}>Home</Link>
            <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
            <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans',sans-serif" }}>Sales</span>
          </div>
        </section>

        {/* ─── Stats ─── */}
        <section className="ap-stats" style={{ flexShrink: 0 }}>
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL SALES</div>
              <div className="ap-stat-value">{allsales.length}</div>
              <div className="ap-stat-badge green">↑ Active members</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconUsers /></div>
          </div>

          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">ADDED THIS MONTH</div>
              <div className="ap-stat-value large">{thisMonth}</div>
              <div className="ap-stat-badge green">Last 30 days</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconCity /></div>
          </div>

          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">FILTERED RESULTS</div>
              <div className="ap-stat-value white">{filtered.length}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                <span className="ap-badge-pill">SHOWING NOW</span>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>of {allsales.length} total</span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon"><IconTrend /></div>
          </div>
        </section>

        {/* ─── Table Section ─── */}
        <section
          className="ap-table-section"
          style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}
        >
          {/* header */}
          <div className="ap-table-header" style={{ flexShrink: 0 }}>
            <div>
              <div className="ap-table-title-label">TEAM</div>
              <div className="ap-table-title">SALES</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search by name, email, notes…"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                />
              </div>
              <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <IconFilter /> Filter
              </button>
              {/* Action buttons */}
              <button
                onClick={exportToExcel}
                style={{ display:'flex',alignItems:'center',gap:'6px',padding:'9px 14px',background:isDark?'#252540':'#f5f6fa',border:`1px solid ${isDark?'#3a3a5a':'#e0e2ef'}`,borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:500,color:isDark?'#b0b0d0':'#4b5563',fontFamily:"'DM Sans',sans-serif",transition:'all 0.15s',whiteSpace:'nowrap' }}
              >
                <IconDownload /> Export
              </button>
              <button
                onClick={() => setShowImport(true)}
                style={{ display:'flex',alignItems:'center',gap:'6px',padding:'9px 14px',background:'#16a34a',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:500,color:'#fff',fontFamily:"'DM Sans',sans-serif",whiteSpace:'nowrap' }}
              >
                <IconUpload /> Import
              </button>
              {selectedSales.length > 0 && (
                <>
                  <button
                    onClick={() => setShowDelete(true)}
                    style={{ display:'flex',alignItems:'center',gap:'6px',padding:'9px 14px',background:'#E53935',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:500,color:'#fff',fontFamily:"'DM Sans',sans-serif",whiteSpace:'nowrap' }}
                  >
                    <IconTrash /> Delete ({selectedSales.length})
                  </button>
                  {selectedSales.length === 1 && (
                    <Link to={`/updatesales/${selectedSales[0]}`} style={{ textDecoration:'none' }}>
                      <button style={{ display:'flex',alignItems:'center',gap:'6px',padding:'9px 14px',background:'#f59e0b',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:500,color:'#fff',fontFamily:"'DM Sans',sans-serif",whiteSpace:'nowrap' }}>
                        <IconEdit /> Edit
                      </button>
                    </Link>
                  )}
                </>
              )}
              <Link to="/Addsales" style={{ textDecoration:'none' }}>
                <button className="ap-create-btn"><IconPlus /> Add Sales</button>
              </Link>
            </div>
          </div>

          {/* filter row */}
          {showFilter && (
            <div className="ap-filter-row" style={{ flexShrink: 0, alignItems: 'center', gap: '12px' }}>
              <div style={{ minWidth: '180px' }}>
                <SearchableSelect
                  value={roleFilter === 'all' ? '' : roleFilter}
                  onChange={(v) => { setRoleFilter(v === 'all' ? 'all' : v); setPage(1); }}
                  options={uniqueRoles}
                  placeholder="All Roles"
                  isDark={isDark}
                />
              </div>
              <div style={{ minWidth: '180px' }}>
                <SearchableSelect
                  value={cityFilter === 'all' ? '' : cityFilter}
                  onChange={(v) => { setCityFilter(v === 'all' ? 'all' : v); setPage(1); }}
                  options={uniqueCities}
                  placeholder="All Cities"
                  isDark={isDark}
                />
              </div>
              <button
                className="ap-clear-btn"
                onClick={() => { setSearchTerm(''); setRoleFilter('all'); setCityFilter('all'); setPage(1); }}
              >
                Clear
              </button>
            </div>
          )}

          {/* Table */}
          <div className="ap-table-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
            <table className="ap-table">
              <thead>
                <tr>
                  <th style={{ width: 46, position:'sticky',top:0,zIndex:2,background:isDark?'#1a1a2e':'#fff' }}>
                    <input type="checkbox" className="ap-checkbox" checked={isAllSelected} ref={el => { if (el) el.indeterminate = isSomeSelected; }} onChange={handleSelectAll} />
                  </th>
                  {['NAME','CITY','NOTES','USER INFO','CREATED DATE','ACTIONS'].map(h => (
                    <th key={h} style={{ position:'sticky',top:0,zIndex:2,background:isDark?'#1a1a2e':'#fff' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={7} className="ap-empty"><div className="ap-spinner"/><span>Loading sales…</span></td></tr>
                ) : pageItems.length === 0 ? (
                  <tr><td colSpan={7} className="ap-empty"><IconSearch /><p>No sales found</p></td></tr>
                ) : (
                  pageItems.map((sale) => (
                    <tr key={sale._id} className="ap-row" style={{ background: selectedSales.includes(sale._id) ? (isDark ? '#1d2a5e22' : '#eef1fb') : undefined }}>
                      <td>
                        <input type="checkbox" className="ap-checkbox" checked={selectedSales.includes(sale._id)} onChange={() => handleSelectOne(sale._id)} />
                      </td>
                      <td>
                        <div className="ap-project-cell">
                          <div className="ap-project-thumb">{sale.name?.slice(0, 2).toUpperCase() || 'SL'}</div>
                          <span className="ap-project-name">{sale.name || '—'}</span>
                        </div>
                      </td>
                      <td className="ap-cell-muted" style={{ fontSize: 13 }}>{sale.city || '—'}</td>
                      <td className="ap-cell-muted" style={{ fontSize: 13, maxWidth: 180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{sale.notes || '—'}</td>
                      <td>
                        <div style={{ fontSize: 13 }}>
                          <div style={{ fontWeight: 600, color: isDark ? '#e0e0ff' : '#0d1b3e' }}>{sale.userlogName || '—'}</div>
                          {sale.userlogRole && <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: '999px', background: isDark ? '#1d2a5e' : '#eef1fb', color: isDark ? '#90b4ff' : '#0d2a6e', fontWeight: 500 }}>{sale.userlogRole}</span>}
                          <div style={{ fontSize: 11, color: isDark ? '#7070a0' : '#9ca3af', marginTop: 2 }}>{sale.userlogEmail}</div>
                        </div>
                      </td>
                      <td className="ap-cell-muted" style={{ fontSize: 13 }}>{sale.createdAt ? moment(sale.createdAt).format('MMM DD, YYYY') : '—'}</td>
                      <td>
                        <div className="ap-actions">
                          <CopyToClipboard text={sale._id} onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}>
                            <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                          </CopyToClipboard>
                          <Link to={`/updatesales/${sale._id}`}>
                            <button className="ap-action-btn" title="Edit"><IconEdit /></button>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ✅ Pagination sticky */}
          {filtered.length > 0 && (
            <div
              className="ap-pagination"
              style={{ position:'sticky',bottom:0,zIndex:5,flexShrink:0,backgroundColor:isDark?'#1a1a2e':'#fff',borderTop:`1px solid ${isDark?'#2a2a45':'#e8eaf0'}`,boxShadow:'0 -2px 12px rgba(0,0,0,0.06)' }}
            >
              <div className="ap-pagination-info">
                <span>Items per page:</span>
                <select className="ap-page-select" value={itemsPerPage} onChange={e => { setItemsPerPage(Number(e.target.value)); setPage(1); }}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
                <span>Showing <strong>{(page-1)*itemsPerPage+1}–{Math.min(page*itemsPerPage,filtered.length)}</strong> of <strong>{filtered.length}</strong> sales</span>
              </div>
              <div className="ap-pagination-btns">
                <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page===1}>⟨|</button>
                <button className="ap-pag-btn" onClick={() => setPage(p=>Math.max(1,p-1))} disabled={page===1}>‹</button>
                {buildPageNumbers().map((n,i) => n==='...' ? <span key={`e-${i}`} className="ap-pag-ellipsis">…</span> : <button key={n} className={`ap-pag-btn ${page===n?'active':''}`} onClick={() => setPage(n)}>{n}</button>)}
                <button className="ap-pag-btn" onClick={() => setPage(p=>Math.min(totalPages,p+1))} disabled={page===totalPages}>›</button>
                <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page===totalPages}>|⟩</button>
              </div>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ flexShrink: 0 }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>
      </div>

      {/* ─── Delete Modal ─── */}
      {showDelete && (
        <PortalModal
          isDark={isDark}
          title="Delete Selected Sales?"
          subtitle={`You are about to delete ${selectedSales.length} sales member(s). This action will deactivate them.`}
          onClose={() => setShowDelete(false)}
          onConfirm={handleDelete}
          confirmLabel={<><IconTrash /> Delete {selectedSales.length} Sales</>}
          loading={deleteLoading}
        />
      )}

      {/* ─── Import Modal ─── */}
      {showImport && createPortal(
        <div style={{ position:'fixed',inset:0,zIndex:999999,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.75)',backdropFilter:'blur(10px)' }}
          onClick={e => { if (e.target === e.currentTarget) setShowImport(false); }}
        >
          <div style={{ width:'100%',maxWidth:'440px',margin:'0 20px',borderRadius:'24px',padding:'36px 32px',background:isDark?'linear-gradient(135deg,#1a1f2e,#141829)':'#fff',boxShadow:'0 40px 100px rgba(0,0,0,0.35)',position:'relative',color:isDark?'#E4E8F5':'#1C2340' }}>
            <button onClick={() => setShowImport(false)} style={{ position:'absolute',top:14,right:14,width:32,height:32,borderRadius:'8px',border:`1px solid ${isDark?'#3A4570':'#E8EAF0'}`,background:isDark?'#252D4A':'#F7F8FC',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:isDark?'#9099c0':'#7B829A' }}>
              <IconClose />
            </button>
            <div style={{ width:64,height:64,borderRadius:'50%',background:'linear-gradient(135deg,#16a34a22,#16a34a44)',border:'2px solid #16a34a66',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 18px',color:'#16a34a' }}>
              <IconUpload />
            </div>
            <p style={{ fontSize:'18px',fontWeight:700,textAlign:'center',margin:'0 0 6px' }}>Import from Excel</p>
            <p style={{ fontSize:'13px',color:isDark?'#7B829A':'#6b7280',textAlign:'center',margin:'0 0 22px' }}>Upload an .xlsx or .xls file to import sales data</p>

            <label style={{ display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'20px',border:`2px dashed ${isDark?'#3A4570':'#D6E0FF'}`,borderRadius:'12px',cursor:'pointer',background:isDark?'#1d2040':'#F0F4FF',marginBottom:'16px' }}>
              <input type="file" accept=".xlsx,.xls" style={{ display:'none' }} onChange={e => { setImportFile(e.target.files[0]); setImportFileName(e.target.files[0]?.name || ''); }} />
              <IconUpload />
              <span style={{ marginTop:'8px',fontSize:'13px',fontWeight:500,color:isDark?'#7DA4FF':'#1A3ECF' }}>
                {importFileName || 'Click to choose file'}
              </span>
            </label>

            {importMsg && (
              <div style={{ padding:'10px 14px',borderRadius:'10px',background:importMsg.includes('Error') ? '#fef2f2' : '#f0fdf4',color:importMsg.includes('Error') ? '#dc2626' : '#16a34a',fontSize:'13px',marginBottom:'16px' }}>
                {importMsg}
              </div>
            )}

            <div style={{ display:'flex',gap:'10px' }}>
              <button onClick={() => setShowImport(false)} style={{ flex:1,padding:'13px',borderRadius:'12px',border:`1.5px solid ${isDark?'#3A4570':'#E8EAF0'}`,background:isDark?'#252D4A':'#F7F8FC',color:isDark?'#E4E8F5':'#1C2340',fontFamily:"'DM Sans',sans-serif",fontSize:'14px',fontWeight:600,cursor:'pointer' }}>Cancel</button>
              <button onClick={handleImportSubmit} disabled={!importFile || importLoading} style={{ flex:1,padding:'13px',borderRadius:'12px',border:'none',background:'linear-gradient(135deg,#16a34a,#15803d)',color:'#fff',fontFamily:"'DM Sans',sans-serif",fontSize:'14px',fontWeight:700,cursor:!importFile||importLoading?'not-allowed':'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',opacity:!importFile||importLoading?0.7:1 }}>
                {importLoading ? <><div style={{ width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',borderTopColor:'#fff',borderRadius:'50%',animation:'pm-spin 0.7s linear infinite' }}/>Importing…</> : <><IconUpload />Import File</>}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};
